export default __webpack_public_path__ + "static/media/nubianClubCollaboration.8d339569.jpeg";